// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-InfoSection-styles--root--azH1h {
  position: relative;
  padding: 15px 35px 15px 45px;
  background-color: #fff;
}

@media screen and (min-width: 768px) {

.src-components-InfoSection-styles--root--azH1h {
    padding: 20px 75px 25px;
}
  }

@media screen and (min-width: 1024px) {

.src-components-InfoSection-styles--root--azH1h {
    padding-left: 20px;
    padding-right: 20px;
}
  }

@media screen and (min-width: 1280px) {

.src-components-InfoSection-styles--root--azH1h {
    padding-left: 55px;
    padding-right: 40px;
}
  }

.src-components-InfoSection-styles--root--azH1h::after {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    border-bottom: 1px solid #e8eaf0;
    border-bottom: 1px solid var(--lightGrayBlue);
    height: 1px;
    content: '';
  }

@media screen and (min-width: 768px) {

.src-components-InfoSection-styles--root--azH1h::after {
      left: 75px;
      right: 75px;
  }
    }

@media screen and (min-width: 1024px) {

.src-components-InfoSection-styles--root--azH1h::after {
      display: none;
  }
    }

.src-components-InfoSection-styles--root--azH1h h4,.src-components-InfoSection-styles--root--azH1h h4 + div {
    margin: 0;
    margin: initial;
    padding: 0;
    padding: initial;
  }

.src-components-InfoSection-styles--root--azH1h h4 {
    position: relative;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.47;
  }

.src-components-InfoSection-styles--root--azH1h h4 a {
    display: block;
  }

.src-components-InfoSection-styles--root--azH1h h4 a:hover + svg,.src-components-InfoSection-styles--root--azH1h h4 a:focus + svg {
      fill: #315efb !important;
      fill: var(--primaryForeground) !important;
    }

.src-components-InfoSection-styles--root--azH1h h4 svg {
    position: absolute;
    top: 5px;
    right: -20px;
  }

@media screen and (min-width: 768px) {

.src-components-InfoSection-styles--root--azH1h h4 svg {
      right: 5px;
  }
    }

@media screen and (min-width: 1024px) {

.src-components-InfoSection-styles--root--azH1h h4 svg {
      visibility: hidden;
  }
    }

@media screen and (min-width: 1280px) {

.src-components-InfoSection-styles--root--azH1h h4 svg {
      right: -20px;
      visibility: visible;
  }
    }

.src-components-InfoSection-styles--root--azH1h h4 + div {
    display: none;
  }

@media screen and (min-width: 768px) {

.src-components-InfoSection-styles--root--azH1h h4 + div {
      display: block;
      margin-top: 10px;
      font-size: 14px;
      line-height: 1.43;
  }
    }

@media screen and (min-width: 1024px) {

.src-components-InfoSection-styles--root--azH1h h4 + div {
      line-height: 1.58;
  }
    }

.src-components-InfoSection-styles--root--azH1h p {
    margin: 0;
    padding: 0;
  }

.src-components-InfoSection-styles--root--azH1h p + p {
    margin-top: 10px;
  }

@media screen and (min-width: 1024px) {
  .src-components-InfoSection-styles--root--azH1h + .src-components-InfoSection-styles--root--azH1h {
    margin-top: 25px;
  }
}

.src-components-InfoSection-styles--icon--ML0XK {
  float: left;
  box-sizing: border-box;
  border-radius: 100px;
  display: flex;
  width: 25px;
  height: 25px;
  margin-left: -35px;
  background-color: #f3f4f7;
}

@media screen and (min-width: 1024px) {

.src-components-InfoSection-styles--icon--ML0XK {
    float: none;
    margin-left: 0;
    margin-bottom: 5px;
}
  }

@media screen and (min-width: 1280px) {

.src-components-InfoSection-styles--icon--ML0XK {
    float: left;
    margin-left: -35px;
    margin-bottom: 0;
}
  }

.src-components-InfoSection-styles--icon--ML0XK svg {
    margin: auto;
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/InfoSection/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AAmGxB;;AAjGE;;AALF;IAMI,uBAAuB;AAgG3B;EA/FE;;AAEA;;AATF;IAUI,kBAAkB;IAClB,mBAAmB;AA2FvB;EA1FE;;AAEA;;AAdF;IAeI,kBAAkB;IAClB,mBAAmB;AAsFvB;EArFE;;AAEA;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,gCAA6C;IAA7C,6CAA6C;IAC7C,WAAW;IACX,WAAW;EAUb;;AARE;;AATF;MAUI,UAAU;MACV,WAAW;EAMf;IALE;;AAEA;;AAdF;MAeI,aAAa;EAEjB;IADE;;AAGF;IAEE,SAAe;IAAf,eAAe;IACf,UAAgB;IAAhB,gBAAgB;EAClB;;AAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;AAEA;IACE,cAAc;EAMhB;;AAJE;MAEE,wBAAyC;MAAzC,yCAAyC;IAC3C;;AAGF;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;EAcd;;AAZE;;AALF;MAMI,UAAU;EAWd;IAVE;;AAEA;;AATF;MAUI,kBAAkB;EAOtB;IANE;;AAEA;;AAbF;MAcI,YAAY;MACZ,mBAAmB;EAEvB;IADE;;AAGF;IACE,aAAa;EAYf;;AAVE;;AAHF;MAII,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB;EAMrB;IALE;;AAEA;;AAVF;MAWI,iBAAiB;EAErB;IADE;;AAGF;IACE,SAAS;IACT,UAAU;EACZ;;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAiB3B;;AAfE;;AAVF;IAWI,WAAW;IACX,cAAc;IACd,kBAAkB;AAYtB;EAXE;;AAEA;;AAhBF;IAiBI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AAMpB;EALE;;AAEA;IACE,YAAY;EACd","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  position: relative;\n  padding: 15px 35px 15px 45px;\n  background-color: #fff;\n\n  @media (--desktop) {\n    padding: 20px 75px 25px;\n  }\n\n  @media (--desktop-l) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  @media (--desktop-x) {\n    padding-left: 55px;\n    padding-right: 40px;\n  }\n\n  &::after {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    border-bottom: 1px solid var(--lightGrayBlue);\n    height: 1px;\n    content: '';\n\n    @media (--desktop) {\n      left: 75px;\n      right: 75px;\n    }\n\n    @media (--desktop-l) {\n      display: none;\n    }\n  }\n\n  & h4,\n  & h4 + div {\n    margin: initial;\n    padding: initial;\n  }\n\n  & h4 {\n    position: relative;\n    font-size: 17px;\n    font-weight: 500;\n    line-height: 1.47;\n  }\n\n  & h4 a {\n    display: block;\n\n    &:hover + svg,\n    &:focus + svg {\n      fill: var(--primaryForeground) !important;\n    }\n  }\n\n  & h4 svg {\n    position: absolute;\n    top: 5px;\n    right: -20px;\n\n    @media (--desktop) {\n      right: 5px;\n    }\n\n    @media (--desktop-l) {\n      visibility: hidden;\n    }\n\n    @media (--desktop-x) {\n      right: -20px;\n      visibility: visible;\n    }\n  }\n\n  & h4 + div {\n    display: none;\n\n    @media (--desktop) {\n      display: block;\n      margin-top: 10px;\n      font-size: 14px;\n      line-height: 1.43;\n    }\n\n    @media (--desktop-l) {\n      line-height: 1.58;\n    }\n  }\n\n  & p {\n    margin: 0;\n    padding: 0;\n  }\n\n  & p + p {\n    margin-top: 10px;\n  }\n}\n\n@media (--desktop-l) {\n  .root + .root {\n    margin-top: 25px;\n  }\n}\n\n.icon {\n  float: left;\n  box-sizing: border-box;\n  border-radius: 100px;\n  display: flex;\n  width: 25px;\n  height: 25px;\n  margin-left: -35px;\n  background-color: #f3f4f7;\n\n  @media (--desktop-l) {\n    float: none;\n    margin-left: 0;\n    margin-bottom: 5px;\n  }\n\n  @media (--desktop-x) {\n    float: left;\n    margin-left: -35px;\n    margin-bottom: 0;\n  }\n\n  & svg {\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-InfoSection-styles--root--azH1h`,
	"icon": `src-components-InfoSection-styles--icon--ML0XK`
};
module.exports = ___CSS_LOADER_EXPORT___;
